module.exports = ".Error404 {\n  padding: 2rem;\n  background-color: white; }\n"